/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable-next-line array-callback-return */
import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import SideDrawer from './../../Components/SideDrawer';
import { createTheme, ThemeProvider } from "@mui/material";
import { DestroyResourceAction, LoadResourceAction } from "../../Redux/Actions/CrudActions";
import { useSelector, useDispatch } from 'react-redux';
import RequestsEdit from './Edit';
import { UpdateDataService } from "../../Services/CrudServices";
import { Spinner } from "../../Components/Spinner";

const SetingsGrid = ({ columns, dataList, setDataList, Title, HandleDrawerCreate }) => {

    const ACTION_TYPE = "COMMON";
    const BACKEND_ROUTE = "customer-requests";
    const theme = createTheme();

    const [id, setID] = React.useState(null);
    const [refreshTable, setRefreshTable] = useState(false);
    const [editDrawerStatus, setEditDrawerStatus] = React.useState(null);

    const state = useSelector(state => state.common);

    const dispatch = useDispatch();

    useEffect(() => {
        if (refreshTable) {
            dispatch(LoadResourceAction(BACKEND_ROUTE, ACTION_TYPE));
            setRefreshTable(false);
        };
    }, [refreshTable]);

    const HandleEditDrawer = (event) => {
        if (editDrawerStatus) {
            setID(null);
            setEditDrawerStatus(false);
        }
    }
    const HandleEdit = (rowData) => {
        setID(rowData.id);
        setEditDrawerStatus(true);
    }

    const HandleApprove = (rowData) => {

        const updateURL = BACKEND_ROUTE + "/" + rowData.id + "/update-status";
        const payLoad = {
            _method: "PUT",
            mstr_req_st_id: 2
        };

        UpdateDataService(updateURL, payLoad).then((res) => {
            // console.log(res);
            setRefreshTable(true);
        }, error => {
            console.log("error");
        });

    }

    const HandleReject = (rowData) => {

        const updateURL = BACKEND_ROUTE + "/" + rowData.id + "/update-status";
        const payLoad = {
            _method: "PUT",
            mstr_req_st_id: 3
        };

        UpdateDataService(updateURL, payLoad).then((res) => {
            // console.log(res);
            setRefreshTable(true);
        }, error => {
            console.log("error");
        });
    }

    const handleDelete = (oldData) => {
        var ID = oldData.id;
        dispatch(DestroyResourceAction(BACKEND_ROUTE, ID, ACTION_TYPE));
        console.log(state);
    }

    return (
        <ThemeProvider theme={theme}>
            <div style={{ maxWidth: '100%' }}>
                <MaterialTable
                    columns={columns.columns}
                    data={dataList}
                    title={state.all.loading ? <Spinner />: Title}
                    isLoading={state.all.loading}
                    actions={[
                        {
                            icon: 'edit',
                            tooltip: 'Edit',
                            onClick: (event, rowData) => HandleEdit(rowData)
                        },
                        {
                            icon: () => <span className="btn btn-sm btn-theme-primary ml-2">Create a Setting</span>,
                            tooltip: 'Create a Setting',
                            isFreeAction: true,
                            onClick: (event, rowData) => HandleDrawerCreate()
                        },
                    ]}
                    editable={{
                        onRowDelete: (oldData) =>
                            new Promise((resolve) => {
                                setTimeout(() => {
                                    resolve();
                                    const data = [...dataList]
                                    data.splice(data.indexOf(oldData), 1);
                                    setDataList(data)
                                    handleDelete(oldData)
                                }, 600);
                            }),
                    }}
                    options={{
                        actionsColumnIndex: 0
                    }}

                />
            </div>
            <SideDrawer status={editDrawerStatus} handle={HandleEditDrawer} >
                {id && <RequestsEdit ID={id} />}
            </SideDrawer>
        </ThemeProvider>
    );
}

export default SetingsGrid;